import { render, staticRenderFns } from "./humanInjuryAdjustment.vue?vue&type=template&id=61364d77&scoped=true"
import script from "./humanInjuryAdjustment.vue?vue&type=script&lang=js"
export * from "./humanInjuryAdjustment.vue?vue&type=script&lang=js"
import style0 from "./humanInjuryAdjustment.vue?vue&type=style&index=0&id=61364d77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61364d77",
  null
  
)

export default component.exports